import { J3Onoff } from '@e3dc-react/icons'
import { Box, CardMedia, IconButton, Typography } from '@mui/material'
import React from 'react'
import { useDispatch } from 'react-redux'
import { Element } from 'src/Libs/shop/models'
import { removePowerMeter } from 'src/State/ShopSystemConfiguration/ShopSystemConfigurationAction'
import { makeStyles } from 'tss-react/mui'
import { PowerMeterLimits, ProductType, ShopImageThumnbailSizes } from 'src/Libs/shop/types'
import { getImageUrlBySize } from 'src/Libs/shop'

interface PowerMeterSystemConfigurationItemCardProps {
  powerMeterData: Element
  powerMeterHighestId: string
}

const useStyles = makeStyles()(theme => ({
  mainComponentWrapper: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '8px',
    marginTop: theme.spacing(2),
    minWidth: '130px',
    flex: '1 auto',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'space-between',
      minWidth: 0,
    },
  },
  spaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '8px',
  },
  icon: {
    color: theme.palette.text.headerTitle,
    transform: 'rotate(90deg) translateY(-12px)',
  },
  powerMeterName: {
    wordWrap: 'break-word',
  },
}))

const PowerMeterSystemConfigurationItemCard: React.FC<PowerMeterSystemConfigurationItemCardProps> = ({ powerMeterData, powerMeterHighestId }) => {
  const { classes } = useStyles()
  const dispatch = useDispatch()
  const isPowerMeter = powerMeterData.extensions.e3dcData.customFields.productType === ProductType.PowerMeter
  const isHighestId = powerMeterData.extensions.e3dcData.customFields.powerMeterId === powerMeterHighestId
  const isPowerMeterId105 = powerMeterData.extensions.e3dcData.customFields.powerMeterId === PowerMeterLimits.FarmingId
  const isPowerMeterId106 = powerMeterData.extensions.e3dcData.customFields.powerMeterId === PowerMeterLimits.HouseConnectionId

  const showRemoveButton = isPowerMeter && (isHighestId || isPowerMeterId105 || isPowerMeterId106)

  const productImageUrl = getImageUrlBySize(powerMeterData?.cover?.media?.thumbnails, ShopImageThumnbailSizes.ExtraSmall)
  return (
    <Box className={classes.mainComponentWrapper}>
      <Box className={classes.spaceBetween}>
        <CardMedia component="img" image={productImageUrl} sx={{ maxWidth: '45px', height: '100%' }} />
        <Typography variant="h4" className={classes.powerMeterName}>
          {powerMeterData.translated.name}
        </Typography>
      </Box>
      {showRemoveButton && (
        <IconButton
          onClick={() => {
            dispatch(removePowerMeter(powerMeterData.id))
          }}
        >
          <J3Onoff fontSize="large" className={classes.icon} />
        </IconButton>
      )}
    </Box>
  )
}

export default PowerMeterSystemConfigurationItemCard
